export class RestrictedConstant {
  static readonly TOOLTIP = 'Result will not display content for restricted source. Click to learn more.';
  static readonly URL = 'https://help.unleash.so/docs/restricted-links';
}
